import Wrapper from "layouts/wrapper"
import Layout from "layouts/layout"
import Error from "components/error"
import Routes from "./routes"

export default function PagesIndex() {
  return (
    <Wrapper>
      <Layout>
        <Error>
          <Routes />
        </Error>
      </Layout>
    </Wrapper>
  )
}
